import { render, staticRenderFns } from "./DeleteCollection.vue?vue&type=template&id=6720e632&"
import script from "./DeleteCollection.vue?vue&type=script&lang=js&"
export * from "./DeleteCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports